var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"app-switch mr-3"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.handleChange()}}}),_c('span',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }